import { render, staticRenderFns } from "./AddictiveStuffDelete.vue?vue&type=template&id=0ed05053&scoped=true&"
import script from "./AddictiveStuffDelete.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed05053",
  null
  
)

export default component.exports